import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const conditions = {
  'non-functioning': 'nonFunctioning',
  poor: 'poor',
  fair: 'fair',
  good: 'good',
  'very-good': 'veryGood',
  excellent: 'excellent',
  mint: 'mint',
  'mint-inventory': 'mintInventory',
  'b-stock': 'bStock',
  'brand-new': 'brandNew',
};

class ConditionExplanation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      condition: props.condition,
    };
  }

  componentDidMount() {
    this.bindSelectChange();
  }

  bindSelectChange() {
    $(document).on('change', this.props.selectField, () => this.setCondition());
  }

  setCondition() {
    const condition = $(this.props.selectField).val();
    this.setState({ condition });
  }

  explanationMessage(selectedCondition) {
    const props = {
      span_open: '<span>',
      span_close: '</span>',
      no_break: '&nbsp;',
    };
    const msg = I18n.t(`js.listingForm.conditionExplanation.${selectedCondition}`, props);

    return { __html: msg };
  }

  conditionClassNames() {
    return (
      classNames(
        'condition-explanation',
        `condition-explanation--${this.state.condition}`,
      )
    );
  }

  render() {
    const selectedCondition = conditions[this.state.condition];

    if (selectedCondition) {
      return (
        <div
          className={this.conditionClassNames()}
        >
          <div
            className="d-inline mr-space"
            dangerouslySetInnerHTML={this.explanationMessage(selectedCondition)}
          />
          <a
            href="https://help.reverb.com/hc/en-us/articles/360013525833"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-r-external-link"
          >
            {I18n.t('js.listingForm.conditionExplanation.learnMore')}
          </a>
        </div>
      );
    }

    return (
      <div
        className="condition-explanation"
      >
        <a
          href="https://help.reverb.com/hc/en-us/articles/360013525833"
          target="_blank"
          rel="noopener noreferrer"
          className="icon-r-external-link"
        >
          {I18n.t('js.listingForm.conditionExplanation.learnMoreExtended')}
        </a>
      </div>
    );
  }
}

ConditionExplanation.propTypes = {
  selectField: PropTypes.string.isRequired,
  condition: PropTypes.string,
};

export default ConditionExplanation;
